<div
  class="autocomplete-container"
  aria-owns="suggestions suggestions-history"
  [attr.aria-expanded]="isOpen"
  [ngClass]="{ active: isOpen }"
>
  <div class="input-container">
    <input
      #searchInput
      avInput
      type="text"
      attr.aria-label="{{ placeholder }}"
      aria-autocomplete="list"
      role="combobox"
      placeholder="{{ placeholder }}"
      [(ngModel)]="query"
      (input)="onChange($event)"
      (focus)="handleFocus($event)"
      (blur)="onTouched($event)"
      [disabled]="disabled"
      autocomplete="off"
    />
    @if (query && !isLoading && !disabled) {
    <div class="x" (click)="remove($event)">
      <av-icon size="md" name="close"></av-icon>
    </div>
    }
    <!--Loading mask-->
    @if (isLoading) {
    <av-spinner size="sm"></av-spinner>
    }
  </div>

  <!--FilteredList items-->
  <av-card
    [backdrop]="false"
    class="suggestions-container"
    id="suggestions"
    role="listbox"
    [ngClass]="{
      'is-hidden': isHistoryListVisible(),
      'is-visible': !isHistoryListVisible()
    }"
  >
    <!--FilteredList heading-->
    @if (filteredList.length > 0 && heading) {
    <div class="heading">
      <div class="text">{{ heading }}</div>
    </div>
    }

    <ul #filteredListElement>
      @for (item of filteredList; track $index; let idx = $index) {
      <li class="item">
        <!--string logic-->
        @if (isTypeString(item)) {
        <div
          [class.complete-selected]="idx === selectedIdx"
          (click)="select(item)"
        >
          <ng-container
            *ngTemplateOutlet="
              itemTemplate;
              context: { $implicit: item | highlight : toHighlight }
            "
          >
          </ng-container>
        </div>
        }
        <!--object logic-->
        @if (!isTypeString(item)) {
        <div
          [class.complete-selected]="idx === selectedIdx"
          (click)="select(item)"
        >
          <ng-container
            *ngTemplateOutlet="
              itemTemplate;
              context: {
                $implicit: item | highlight : toHighlight : searchKeyword
              }
            "
          >
          </ng-container>
        </div>
        }
      </li>
      }
    </ul>
  </av-card>

  <!--HistoryList items-->
  <div
    class="suggestions-container"
    id="suggestions-history"
    role="listbox"
    [ngClass]="{
      'is-hidden': !isHistoryListVisible(),
      'is-visible': isHistoryListVisible()
    }"
  >
    <!--HistoryList heading-->
    @if (historyList.length > 0 && historyHeading) {
    <div class="heading">
      <div class="text">{{ historyHeading }}</div>
      <div class="x" (click)="resetHistoryList($event)">
        <i class="material-icons" [attr.aria-label]="'Delete' | translate"
          >delete</i
        >
      </div>
    </div>
    }

    <ul #historyListElement>
      @for (item of historyList; track $index; let idx = $index) {
      <li class="item">
        <!--string logic-->
        @if (isTypeString(item)) {
        <div
          [class.complete-selected]="idx === selectedIdx"
          (click)="select(item)"
        >
          <ng-container
            *ngTemplateOutlet="itemTemplate; context: { $implicit: item }"
          >
          </ng-container>
        </div>
        }
        <!--object logic-->
        @if (!isTypeString(item)) {
        <div
          [class.complete-selected]="idx === selectedIdx"
          (click)="select(item)"
        >
          <ng-container
            *ngTemplateOutlet="itemTemplate; context: { $implicit: item }"
          >
          </ng-container>
        </div>
        }
        <div class="x" (click)="removeHistoryItem(idx, $event)">
          <i class="material-icons" [attr.aria-label]="'Close' | translate"
            >close</i
          >
        </div>
      </li>
      }
    </ul>
  </div>

  <!--Not found-->
  @if (isLoading ? !isLoading && notFound : notFound) {
  <av-card [backdrop]="false" class="not-found">
    <ng-container
      *ngTemplateOutlet="notFoundTemplate; context: { $implicit: notFoundText }"
    >
    </ng-container>
  </av-card>
  }
</div>
@if (overlay) {
<div class="autocomplete-overlay" (click)="handleOverlay()"></div>
}
